import { useEffect } from 'react';
import { useDevOpsReportPreconditionResource } from '@atlassian/jira-router-resources-devops-report-group/src/services/index.tsx';
import type { PreconditionResult } from '@atlassian/jira-router-resources-devops-report-group/src/types.tsx';

export const useDevOpsReportPreconditionResourceAutoRefetch = () => {
	const { data, loading, error, refresh } = useDevOpsReportPreconditionResource();
	// In case someone forgets adding our precondition resource to any Reports page, this will at least fetch the precondition and render the menu
	useEffect(() => {
		if (loading === false && data == null) {
			if (error) {
				throw error;
			}
			refresh();
		}
	}, [data, error, loading, refresh]);

	return data;
};

export const shouldCycleTimeReportRendered = (
	devOpsReportGroupPrecondition: PreconditionResult,
): boolean =>
	devOpsReportGroupPrecondition.hasViewDevToolsPermission &&
	devOpsReportGroupPrecondition.hasViewAggregateDataPermission;

export const shouldDeploymentFrequencyReportRendered = (
	devOpsReportGroupPrecondition: PreconditionResult,
): boolean =>
	devOpsReportGroupPrecondition.hasViewDevToolsPermission &&
	devOpsReportGroupPrecondition.hasViewAggregateDataPermission;
